import { defineComponent as i, openBlock as s, createBlock as a, unref as p, mergeProps as g, withCtx as r, renderSlot as n } from "vue";
import f from "./ghl-ui.es374.js";
const m = i({
  name: "UITooltip",
  inheritAttrs: !1
}), d = i({
  ...m,
  props: {
    trigger: {
      type: String,
      default: "hover"
    },
    placement: {
      type: String,
      default: void 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  setup(t) {
    return (e, o) => (s(), a(p(f), g(e.$attrs, {
      trigger: t.trigger,
      show: t.show,
      placement: t.placement,
      "onUpdate:show": o[0] || (o[0] = (l) => e.$emit("show", l))
    }), {
      trigger: r(() => [
        n(e.$slots, "trigger")
      ]),
      default: r(() => [
        n(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["trigger", "show", "placement"]));
  }
}), w = d;
export {
  w as default
};
